export function parseSkillsString(skillsString) {
  return skillsString
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
}

export function formatSkillsArray(skillsArray) {
  return (skillsArray || []).join(", ");
}

export function projectToFormData(project) {
  return {
    title: project.title || "",
    github: project.github || "",
    image: project.image || "",
    skills: formatSkillsArray(project.skills),
    demoUrl: project.demoUrl || "",
    listed: project.listed !== false,
  };
}

export function formDataToProject(formData) {
  return {
    title: formData.title,
    github: formData.github,
    image: formData.image,
    skills: parseSkillsString(formData.skills),
    demoUrl: formData.demoUrl || undefined,
    listed: formData.listed,
  };
}
